import { Box } from '@chakra-ui/react';
import dayjs from 'dayjs';
import FullPageLoader from '../../../../components/full-page-loader';
import ValidVisitDetails from './ValidVisitDetails';
const dayOfYear = require('dayjs/plugin/dayOfYear');
dayjs.extend(dayOfYear);

export const ValidationConfirmation = ({ loading, handleSubmit, guestCode, onclickBack, invitedGuest, setConfirmationMsg, confirmationMsg }) => {
  const guest = invitedGuest?.guests?.filter((guest) => guest?.guestCode === guestCode);
  console.log(guest, "...")

  return loading ? (
    <FullPageLoader bg='#f2f2f2' h='100%' />
  ) : (
    <Box className='confirmation-data' bg='#fff' paddingLeft='35px' color='#4f4d4d' borderRadius='3px'>
      <ValidVisitDetails
        setConfirmationMsg={setConfirmationMsg}
        confirmationMsg={confirmationMsg}
        guest={guest}
        handleSubmit={handleSubmit}
        guestCode={guestCode}
        onclickBack={onclickBack}
      />
    </Box>
  );
};
